import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    GET_LIST_REWARD_HISTORIES,
    GET_LIST_REWARD_CUSTOMER_HAS,
    REWARD_GET_CONFIG
} from './types';

const ENDPOINT = '/reward-spin';

const notifyError = (error, fallback) => {
    NotificationManager.error(error?.response?.data?.msg || fallback);
    throw error;
};

export const getListRewardHistories = filter => dispatch => api
    .get(ENDPOINT, { params: filter })
    .then(response => {
        dispatch({ type: GET_LIST_REWARD_HISTORIES, payload: response.data.data });
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể tải danh sách quay thưởng.'));

export const getListRewardCustomerHas = filter => dispatch => api
    .get(`${ENDPOINT}/customer-has-list`, { params: filter })
    .then(response => {
        dispatch({ type: GET_LIST_REWARD_CUSTOMER_HAS, payload: response.data.data });
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể tải danh sách khách hàng đã quay.'));

export const getSpecificRewardHistories = id => () => api
    .get(`${ENDPOINT}/detail/${id}`)
    .then(response => response.data.data)
    .catch(error => notifyError(error, 'Không thể tải chi tiết kết quả quay thưởng.'));

export const rewardUpdateConfig = data => () => api
    .post(`${ENDPOINT}/config`, data)
    .then(response => {
        NotificationManager.success('Cập nhật cấu hình quay thưởng thành công!');
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể cập nhật cấu hình quay thưởng.'));

export const rewardGetConfig = () => dispatch => api
    .get(`${ENDPOINT}/get-config`)
    .then(response => {
        dispatch({ type: REWARD_GET_CONFIG, payload: response.data.data });
        return response.data.data;
    })
    .catch(error => notifyError(error, 'Không thể tải cấu hình quay thưởng.'));

export const removeRewardHistories = (ids, tab) => () => api
    .delete(ENDPOINT, { data: { ids, tab } })
    .then(response => {
        NotificationManager.success('Xóa bản ghi thành công!');
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể xóa kết quả quay thưởng.'));

export const removeRewardCustomerHas = ids => () => api
    .delete(`${ENDPOINT}/remove/customer-has`, { data: { ids } })
    .then(response => {
        NotificationManager.success('Xóa khách hàng đã quay thành công!');
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể xóa khách hàng đã quay.'));

export const spinReward = () => () => api
    .post(`${ENDPOINT}/random-customers`)
    .then(response => response.data)
    .catch(error => notifyError(error, 'Không thể thực hiện quay thưởng.'));

export const updateSpecificSpinHistories = (id, data) => () => api
    .put(`${ENDPOINT}/${id}`, data)
    .then(response => {
        NotificationManager.success('Cập nhật kết quả quay thưởng thành công!');
        return response.data;
    })
    .catch(error => notifyError(error, 'Không thể cập nhật kết quả quay thưởng.'));
